import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SessionTimeout = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = 60000 * 15;
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        localStorage.removeItem("token");
        window.dispatchEvent(new Event('auth-token-changed'));
        navigate("/login");
      }, timeout);
    };

    const events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];

    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(timer);
    };
  }, [navigate]);

  return <>{children}</>;
};

export default SessionTimeout;